import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { QualityControlMessage } from './shared/QualityControlMessage';
import { BaseMessage } from './BaseMessage';

export const AnalyzeArticleTaskMessage = () => {
  const { article, iam } = useArticleContext();

  const isLastQualityControlKO = article.steps?.findLast(
    (step) => step.status === 'cancelled' && step.step === 'quality-control'
  );

  if (!iam.hasUserScopeOnArticle('workshop')) {
    return (
      <BaseMessage
        title={
          <Trans id="article.task.analyze-article.on-behalf.title">An expertise is required</Trans>
        }
        message={
          <Trans id="article.task.analyze-article.on-behalf.message">
            Please contact the workshop to know if they determine that the required item's actions
            correspond to its needs.
          </Trans>
        }
        article={article}
      />
    );
  }

  return (
    <BaseMessage
      title={<Trans id="article.task.analyze-article.title">Analyze the item</Trans>}
      message={
        <Stack gap="0.25rem">
          <p>
            <Trans id="article.task.analyze-article.message">
              Please analyze the item and review the quote to ensure it matches the actual scope and
              pricing.
            </Trans>
          </p>
          {isLastQualityControlKO && <QualityControlMessage article={article} />}
        </Stack>
      }
      article={article}
    />
  );
};
